class Customer.Operator extends Backbone.Model
  defaults:
    id: 0
    type: ''
    user_id: 0
    user: {}

  parse: (response) ->
    @user = new Keepcon.User(response.user)
    super(response)

class Customer.OperatorCollection extends Backbone.Collection
  model: Customer.Operator
  url: '/customer/operators'

